import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
  customerInfoService,
  CreateCustomerInfoDTO,
  UpdateCustomerInfoDTO,
} from '../api/services/customerInfoService';
import toast from 'react-hot-toast';

export function useCustomerInfo() {
  return useQuery({
    queryKey: ['customerInfo'],
    queryFn: customerInfoService.getAllCustomerInfo,
  });
}

export function usePaymentTerms() {
  return useQuery({
    queryKey: ['paymentTerms'],
    queryFn: customerInfoService.getPaymentTerms,
  });
}

export function useShippingMethods() {
  return useQuery({
    queryKey: ['shippingMethods'],
    queryFn: customerInfoService.getShippingMethods,
  });
}

export function useCreateCustomerInfo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateCustomerInfoDTO) => customerInfoService.createCustomerInfo(data),
    onSuccess: () => {
      toast.success('Customer configuration created successfully');
      queryClient.invalidateQueries({ queryKey: ['customerInfo'] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to create customer configuration');
    },
  });
}

export function useUpdateCustomerInfo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateCustomerInfoDTO }) =>
      customerInfoService.updateCustomerInfo(id, data),
    onSuccess: () => {
      toast.success('Customer configuration updated successfully');
      queryClient.invalidateQueries({ queryKey: ['customerInfo'] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to update customer configuration');
    },
  });
}

export function useDeleteCustomerInfo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => customerInfoService.deleteCustomerInfo(id),
    onSuccess: () => {
      toast.success('Customer configuration deleted successfully');
      queryClient.invalidateQueries({ queryKey: ['customerInfo'] });
    },
    onError: (error: any) => {
      toast.error(error.response?.data?.message || 'Failed to delete customer configuration');
    },
  });
}
